import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  ATLTinckerpreneurTarget,
  ATLTinckerpreneurObjective,
  ATLTinkerpreneurBanner,
  ATLTinkerpreneurGuidelines,
  ATLTinkerpreneurTimeline,
  ATLTinckerpreneurDisclaimer,
} from "../components/ATLTinckerpreneur";
import { LanguageSwitcher } from "../components/shared";

const Section = styled.div`
  margin-top: 35px;

  @media (min-width: 992px) {
    margin-top: 55px;
  }
`;

const Box = styled.div`
  font-size: 18px !important;
  color: #000 !important;
  border: 3px solid #ff8f4e;
  border-radius: 10px;

  @media (max-width: 768px) {
    font-size: 14px !important;
  }
`;
const AwardTxt = styled.div`
  font-size: 18px !important;
  color: #000 !important;
  padding: 10px;
  background-color: rgb(178, 217, 255);

  @media (max-width: 768px) {
    font-size: 14px !important;
  }
`;

const IndiaAITinkerpreneurPage2025 = () => {
  const token = localStorage.getItem("jwtToken");
  const [timelineData, setTimelineData] = useState([]);
  const year = 2025;
  const { t } = useTranslation();

  const fetchWorkshopData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/atl-tinkerpreneur/?year=${year}`,
        {
          headers: {
            "x-access-token": token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      setTimelineData(data.workshops || []);
      return data.workshops || [];
    } catch (error) {
      console.error("Failed to fetch timeline data", error);
    }
  };

  const handleEnroll = async (event) => {
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/atl-tinkerpreneur/enroll`, {
        method: "POST",
        headers: {
          "x-access-token": token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ event_id: event._id }),
      });
      await fetchWorkshopData();
    } catch (error) {
      console.error("Enrollment failed", error);
    }
  };

  useEffect(() => {
    const init = async () => {
      if (localStorage.getItem("jwtToken")) {
        await fetchWorkshopData();
      }
    };
    init();
  }, []);

  return (
    <>
      <div className="gray-light-bg">
        <div className="container d-flex justify-content-end">
          <LanguageSwitcher />
        </div>
        <div className="blog-container shadow px-0 pt-0 mt-0">
          <div className="mar-t-15">
            <ATLTinkerpreneurBanner year={year} />
          </div>
          <Section className="px-md-2 px-xl-5 mx-auto">
            <ATLTinckerpreneurObjective />
          </Section>
          <Section className="px-3">
            <h2 className="text-center mb-3">AI Tinkerpreneur 2025 Journey</h2>
            <div className="w-100">
              <img
                src={`images/image.png`}
                className="img-fluid rounded"
                alt="Tinkerpreneur Journey 2025"
              />
            </div>
          </Section>
          <div className="px-md-2 px-xl-5 mx-auto mt-md-4 mt-2 ">
            <div className="row">
              <div className="col-md-12 mt-3">
                <Box className="w-100 p-3 p-md-5">
                  <h2 className="text-center mb-2 mb-md-4">
                    {t("atl_tinkerpreneur.mentor_list_title")}
                  </h2>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="text-left">
                        {t("atl_tinkerpreneur.mentor_list_description")}
                        <a
                          style={{ color: "#0048ff" }}
                          href="/assets/pdf/tinkerpreneur-2025-mentors-list.pdf"
                          target="_blank"
                        >
                          Click here to connect with a Mentor of Change.
                        </a>
                      </div>
                    </div>
                  </div>
                </Box>
              </div>
            </div>
          </div>
          <Section>
            <ATLTinckerpreneurTarget />
          </Section>
          <div className="px-md-2 px-xl-5 mx-auto mt-md-4 mt-2">
            <AwardTxt className="w-100 mt-3">
              <div
                className="col-md-12 text-center"
                style={{ fontWeight: "bold" }}
              >
                {t("atl_tinkerpreneur.award_text")}
              </div>
            </AwardTxt>
          </div>
          {timelineData.length > 0 && (
            <Section>
              <ATLTinkerpreneurTimeline
                key={timelineData.length}
                events={timelineData}
                handleEnroll={handleEnroll}
              />
            </Section>
          )}

          <div className="container">
            <Section className="px-md-2 px-xl-5 mx-auto">
              <ATLTinkerpreneurGuidelines year={year} />
            </Section>

            <Section className="px-md-2 px-xl-5 mx-auto">
              <ATLTinckerpreneurDisclaimer />
            </Section>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndiaAITinkerpreneurPage2025;
